import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Button,
  showNotification as showNotificationAction,
} from 'react-admin';
import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';

class DuplicateButton extends Component {
  handleClick = () => {
    const { push, record, showNotification } = this.props;
    const content = { ...record };
    let event_id = content['id'];
    let apiUrl = '';
    if (process.env.NODE_ENV === 'production') {
      apiUrl = process.env.REACT_APP_PROD_API_URL;
    } else {
      apiUrl = process.env.REACT_APP_STAGING_API_URL;
    }
    fetch(apiUrl + '/events/duplicate_event', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage['token']}`,
      },
      body: JSON.stringify({ event_id: event_id }),
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        push(`/events/${data.new_event_id}`);
      })
      .catch(e => {
        console.error(e);
        showNotification('Error', 'warning');
      });
  };

  render() {
    return <Button label="Duplicate" onClick={this.handleClick} />;
  }
}

DuplicateButton.propTypes = {
  push: PropTypes.func,
  record: PropTypes.object,
  showNotification: PropTypes.func,
};

export default connect(
  null,
  {
    showNotification: showNotificationAction,
    push: pushAction,
  }
)(DuplicateButton);



// WEBPACK FOOTER //
// ./src/duplicateButton.js